import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../core/auth.service';
@Component({
  selector: 'app-sistema',
  templateUrl: './sistema.component.html',
  styleUrls: ['./sistema.component.css']
})
export class SistemaComponent implements OnInit {

  url = '../../assets/datos_api.json';
  // url = 'http://api.datos.mineduc.cl/api/v2/datastreams/TOTAL-DE-ESTUD-MATRI-POR/data.json/?auth_key=ac4933afe2b07513277758368256b597c6772a1d';

  datos:any;

  constructor(private http: HttpClient, public authService: AuthService) { }

  ngOnInit() {
    this.http.get(this.url).subscribe(data => {   // data is already a JSON object
      // console.log(data[0]);
      this.datos = Array.of(data);
      // this.datos = data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modulos/sistema/sistema.component.ts